import React, { useState } from "react";
import { Link } from "react-router-dom";
import BrandLogo from "../BrandLogo";
import { appLoginUrl, appSignupUrl } from "../../config";

interface DuskNavProps {
  onBookDemo: () => void;
}

const LINKS = [
  { to: "/use-cases", label: "Use cases" },
  { to: "/products", label: "Products" },
  { to: "/pricing", label: "Pricing" },
  { to: "/blog", label: "Blog" },
  { to: "/about", label: "Company" },
];

/* A floating frosted pill, top right (DESIGN.md §5). On wide screens the
   sidebar carries the full logo, so the pill shows links and the CTAs; on
   small screens it spans the width and carries the logo and a menu. Sign in
   and Sign up are cross-origin links to the app; Sign up opens the Create
   Account form for a COMPANY account (see appSignupUrl). */
const DuskNav: React.FC<DuskNavProps> = ({ onBookDemo }) => {
  const [open, setOpen] = useState(false);
  const close = () => setOpen(false);

  return (
    <header
      className="dusk-nav"
      onKeyDown={(event) => {
        if (event.key === "Escape") {
          close();
          event.currentTarget
            .querySelector<HTMLButtonElement>(".dusk-nav-burger")
            ?.focus();
        }
      }}
    >
      <nav className="dusk-nav-bar" aria-label="Primary">
        <Link
          to="/"
          className="dusk-nav-logo"
          aria-label="Comtev home"
          onClick={close}
        >
          <BrandLogo surface="dark" width={116} height={21} />
        </Link>
        <ul className="dusk-nav-links">
          {LINKS.map((l) => (
            <li key={l.to}>
              <Link to={l.to}>{l.label}</Link>
            </li>
          ))}
          <li>
            <a href={appLoginUrl()} data-cta="nav-sign-in">
              Sign in
            </a>
          </li>
        </ul>
        <button
          type="button"
          className="dusk-btn dusk-btn-sm dusk-btn-ghost"
          data-cta="book-demo"
          onClick={() => {
            close();
            onBookDemo();
          }}
        >
          Book a demo
        </button>
        <a
          className="dusk-btn dusk-btn-sm"
          href={appSignupUrl()}
          data-cta="nav-sign-up"
        >
          Sign up
        </a>
        <button
          type="button"
          className="dusk-nav-burger"
          aria-label={open ? "Close menu" : "Open menu"}
          aria-expanded={open}
          aria-controls="dusk-nav-sheet"
          onClick={() => setOpen((o) => !o)}
        >
          <svg
            width="18"
            height="18"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            aria-hidden="true"
          >
            {open ? (
              <path d="M6 6l12 12M18 6L6 18" />
            ) : (
              <path d="M4 8h16M4 16h16" />
            )}
          </svg>
        </button>
      </nav>
      {open && (
        <div className="dusk-nav-sheet" id="dusk-nav-sheet">
          {LINKS.map((l) => (
            <Link key={l.to} to={l.to} onClick={close}>
              {l.label}
            </Link>
          ))}
          <a href={appLoginUrl()} data-cta="menu-sign-in">
            Sign in
          </a>
          <a href={appSignupUrl()} data-cta="menu-sign-up">
            Sign up
          </a>
        </div>
      )}
    </header>
  );
};

export default DuskNav;
